// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataTable_wrapper__2Rt65"};